import { Button } from "@/components/ui/button";
import { useStoredAuth } from "@/hooks/useStoredAuth";

export default function Hero() {
  const { user, isAuthenticated } = useStoredAuth();

  const handleGetStarted = () => {
    if (isAuthenticated) {
      // Scroll to features
      const element = document.getElementById('features');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      window.location.href = "/api/login";
    }
  };

  const handleViewPremium = () => {
    const element = document.getElementById('cta');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Inteligencia Artificial
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
              {" "}Fácil y Accesible
            </span>
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Descubre las mejores herramientas de IA, mantente al día con las últimas tendencias, 
            implementa soluciones con nuestros notebooks y accede a los papers más recientes.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {!isAuthenticated && (
              <Button
                onClick={handleGetStarted}
                className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 font-semibold hover:opacity-90"
                size="lg"
              >
                Comenzar Gratis
              </Button>
            )}
            {!user?.isPremium && (
              <Button
                variant="outline"
                onClick={handleViewPremium}
                className="border-2 border-blue-600 text-blue-600 px-8 py-3 font-semibold hover:bg-blue-600 hover:text-white"
                size="lg"
              >
                Ver Premium
              </Button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
